import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=854a35cc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854a35cc')) {
      api.createRecord('854a35cc', component.options)
    } else {
      api.reload('854a35cc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=854a35cc&", function () {
      api.rerender('854a35cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4B60lnwoq7AQO/JS/offershelp.vue"
export default component.exports